module.exports = __webpack_public_path__ + "static/BT-mobile-11-9c1256bc7ed498d4f829ce5c5ac68891.jpg";